import ChoiceStore, {
    fromName,
    fromNameOrId,
} from "data/meta/ChoiceStore";
import asArray from "data/util/asArray";

export const optionId = choiceKey => {
    const options = ChoiceStore.getChoiceByKey(choiceKey).options;
    return name => {
        const opt = fromName(options, name);
        return opt == null ? null : opt.id;
    };
};

export const optionName = choiceKey =>
    ChoiceStore.optionName(choiceKey);

export const optionIsAtomic = choiceKey => {
    const options = ChoiceStore.getChoiceByKey(choiceKey).options;
    return nameOrId => {
        const opt = fromNameOrId(options, nameOrId);
        return opt == null ? null : !!opt.atomic;
    };
};

export const optionLabel = choiceKey => {
    const options = ChoiceStore.getChoiceByKey(choiceKey).options;
    return nameOrId => {
        const opt = fromNameOrId(options, nameOrId);
        return opt == null ? null : opt.label;
    };
};

export const optionsForField = (fieldInfo, instance, choice, includeCurrent = false) => {
    const conditions = fieldInfo.conditions;
    const options = choice.options;
    if (conditions == null || conditions.length === 0) {
        return options;
    }
    const ids = [];
    for (const c of conditions) {
        if (c.expression(instance)) {
            ids.push(...c.optionIds);
        }
    }
    if (includeCurrent) {
        const val = asArray(instance.get(fieldInfo.key));
        for (const v of val) {
            const o = options.find(o => o.name === v);
            if (o) ids.push(o.id);
        }
    }
    return options.filter(o => ids.indexOf(o.id) >= 0);
};



// WEBPACK FOOTER //
// ./app/data/selectors/options.js